export const toTitleCase = (text: string) =>{
    return text.replace(/(^\w|\s\w)/g, m => m.toUpperCase());
}